import React, { useEffect, useState } from "react";
import { NFTCollectionsFilterList } from "../../../api/methods-marketplace";
import NftCardLoader from "../../nft-card/nft-card-loader";
import NftCard from "../../nft-card";
import { useSelector } from "react-redux";
import { getUser } from "../../../redux/reducer/user_reducer";

const OnsaleTab = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const selector = useSelector(getUser);
  const address = selector?.address;

  useEffect(() => {
    const handleCardCollection = async () => {
      setIsLoading(true);

      try {
        const query = `address=${address}&put_on_sale=true`;
        const result = await NFTCollectionsFilterList(query);
        if (result) {
          setData(result.data.data);
          setIsLoading(false);
        }
      } catch (err) {
        console.log("🚀 ~ profile collectable data fetch ~ err:", err);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (address) {
      handleCardCollection();
    } else {
      setIsLoading(false);
    }
  }, [address]);
  return (
    <>
      <div className="flex gap-2 my-6">
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 gap-4 w-full lg:grid-cols-3 xl:grid-cols-4`}
        >
          {isLoading ? (
            [...Array(12)].map((_, index) => <NftCardLoader key={index} />)
          ) : data?.length > 0 ? (
            data.map((collection, index) => (
              <NftCard key={index} data={collection} />
            ))
          ) : (
            <div className="col-span-full text-center">
              <h3 className="text-lg font-semibold text-black">
                No NFTs available
              </h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OnsaleTab;
